import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";

TimeAgo.addDefaultLocale(en);

const timeAgoInWords = (date) => new TimeAgo("en-GB").format(date);

export default timeAgoInWords;
